import script from "./Default.vue?vue&type=script&setup=true&lang=ts"
export * from "./Default.vue?vue&type=script&setup=true&lang=ts"

import "./Default.vue?vue&type=style&index=0&id=ff443da6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff443da6"]])

export default __exports__